import React, { memo } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaArrowRight } from "react-icons/fa";
import RunningDemo from "./RunningDemo";

const contentVariants = {
  enter: { opacity: 0, y: 24 },
  center: { opacity: 1, y: 0 },
};

const FeatureSlide = ({ slide, active }) => {
  const accentText = slide.accent === "blue" ? "text-blue-400" : "text-orange-400";
  const accentBorder = slide.accent === "blue" ? "border-blue-500/30" : "border-orange-500/30";

  return (
    <div className="grid min-w-0 grid-cols-1 items-center gap-6 px-4 py-6 sm:gap-8 sm:px-6 sm:py-8 md:grid-cols-2 md:gap-10 md:px-10 md:py-10 lg:px-12 lg:py-12">
      {/* Left: content */}
      <motion.div
        className="order-2 min-w-0 text-center md:order-1 md:text-left"
        variants={contentVariants}
        initial="enter"
        animate="center"
        transition={{ duration: 0.5, ease: "easeOut" }}
      >
        <span
          className={`mb-3 inline-block rounded-full border ${accentBorder} bg-white/5 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider sm:mb-4 sm:px-3 sm:text-xs ${accentText}`}
        >
          {slide.eyebrow}
        </span>
        <h3 className="text-xl font-bold tracking-tight text-white sm:text-2xl md:text-3xl lg:text-4xl">
          {slide.title}
        </h3>
        <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-white/70 sm:mt-4 sm:text-base md:mx-0 md:text-lg">
          {slide.description}
        </p>
        <Link to={slide.cta.to} className="mt-5 inline-block sm:mt-7">
          <motion.span
            whileHover={{ y: -3 }}
            whileTap={{ scale: 0.97 }}
            className="inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-orange-500 to-amber-500 px-5 py-2.5 text-xs font-semibold text-white shadow-lg shadow-orange-500/20 transition-shadow hover:shadow-orange-500/40 sm:px-6 sm:py-3 sm:text-sm"
          >
            {slide.cta.label}
            <FaArrowRight className="text-xs" />
          </motion.span>
        </Link>
      </motion.div>

      {/* Right: running demo */}
      <div className="order-1 min-w-0 md:order-2">
        <RunningDemo type={slide.demo} active={active} />
      </div>
    </div>
  );
};

export default memo(FeatureSlide);
